import classNames from "classnames";
import backgroundImgDesktop from "../../imagenes/main-call-to-action--desktop.png";
import backgroundImgMobile from "../../imagenes/main-call-to-action--mobile.png";
import { platformUrl } from "../../layout/Navigation/Navigation";
import Link from "../../ui/Link/Link";
import { getPlatform } from "../../utils";
import MarkdownRenderer from "../MarkdownRenderer/MarkdownRenderer";
import "./MainCallToAction.scss";

type MainCallToActionAction = {
	label: string;
	url: string | platformUrl;
	variant?: "primary" | "secondary";
	external?: boolean;
};

export type MainCallToActionContent = {
	enabled: boolean;
	background: { mobile: string; desktop: string };
	title: string;
	content?: string;
	actions?: MainCallToActionAction[];
};

const CallsToAction = ({ actions }: { actions: MainCallToActionAction[] }) => {
	return (
		<div
			className="main-call-to-action__actions"
			role="group"
			aria-label="Main actions">
			{actions.map((action) => {
				let url: string;
				if (typeof action.url === "string") {
					url = action.url;
				} else if (action.url && (action.url as platformUrl).platform) {
					const platform = getPlatform();
					url = platform.isAndroid
						? (action.url as platformUrl).platform.android
						: (action.url as platformUrl).platform.ios;
				} else {
					url = String(action.url ?? "");
				}
				const isExternal = action?.external ?? false;
				return (
					<Link
						key={action.label}
						link={{ label: action.label, url }}
						isExternal={isExternal}
						className={classNames("link--button", {
							"primary-action text-dark": action?.variant === "primary",
							"text-light": action?.variant !== "primary",
						})}
					/>
				);
			})}
		</div>
	);
};

const MainCallToAction = ({
	sectionContent,
	isMobile,
}: {
	sectionContent: MainCallToActionContent;
	isMobile: boolean;
}) => {
	return (
		<section
			className="main-call-to-action with-cover-image"
			style={{
				backgroundImage: `url(${isMobile ? sectionContent?.background?.mobile || backgroundImgMobile : sectionContent?.background?.desktop || backgroundImgDesktop})`,
			}}>
			<div className="content-container keep-color">
				<MarkdownRenderer>{sectionContent.title}</MarkdownRenderer>
				<MarkdownRenderer>{sectionContent.content}</MarkdownRenderer>
				<CallsToAction actions={sectionContent.actions ?? []} />
			</div>
		</section>
	);
};

export default MainCallToAction;
